import * as Types from "../constants/RoleModule";
import { ViewState } from "redux/constants/App";
import { setBusy, setError, setReady } from "./utils";

const initialState = {
    roleModules: [],
    error: {
        status: null,
        message: null,
        errors: [],
    },
    roleModule: {
        roleId: null,
        moduleId: null,
        root: false,
        create: false,
        read: false,
        update: false,
        destroy: false,
    },
    getStatus: ViewState.IDLE,
    attachStatus: ViewState.IDLE,
    permissionStatus: ViewState.IDLE,
    tablePath: '/admin/role_module'
}


const actions = {
    [Types.FETCH_ROLE_MODULES]: (state) => setBusy({ state, statusKey: "getStatus" }),
    [Types.FETCH_ROLE_MODULES_FAILED]: (state, error) => setError({ state, statusKey: "getStatus", error }),
    [Types.FETCH_ROLE_MODULES_OK]: (state, roleModules) => setReady({ state, statusKey: "getStatus", payload: { roleModules } }),

    [Types.ATTACH_MODULE]: (state) => setBusy({ state, statusKey: "attachStatus" }),
    [Types.ATTACH_MODULE_FAILED]: (state, error) => setError({ state, statusKey: "attachStatus", error }),
    [Types.ATTACH_MODULE_OK]: (state, roleModule) => setReady({ state, statusKey: "attachStatus", payload: { roleModule } }),

    [Types.FETCH_ROLE_PERMISSIONS]: (state) => setBusy({ state, statusKey: "permissionStatus" }),
    [Types.FETCH_ROLE_PERMISSIONS_FAILED]: (state, error) => setError({ state, statusKey: "permissionStatus", error }),
    [Types.FETCH_ROLE_PERMISSIONS_OK]: (state, roleModule) => setReady({ state, statusKey: "permissionStatus", payload: { roleModule } }),

    [Types.RESET_ROLE_MODULE]: (_) => Object.assign({}, initialState),
}

export default function (state = initialState, { type: actionType, payload }) {
    const action = actions[actionType];
    if (action) return action(state, payload);
    return state;
}